import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    vConfig:{
    		vmode:'aaa',
    		config:[]
    },
	mnulist:[],
	count:0
};


const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
		UPDATE_VCONFIG_CONFIG:(state, action) => {
			state.vConfig = {...state.vConfig, config:action.payload};
		},
		 UPDATE_VCONFIG_VMODE:(state, action) => {
			state.vConfig = {...state.vConfig, vmode:action.payload};
		},
		SET_COUNT:(state, action) => {
			state.count = state.count + action.payload;
		},	
		RESET_COUNT:(state, action) => {
			state.count = 0;
		},
		 SET_MENU_LIST:(state, action) => {
			let mn = state.mnulist;
			mn[action.payload.idx] = action.payload.mnulist;
			state.mnulist = mn;
		},
		SET_MENU_LOAD_FUNC:(state, action) => {
			state.funcMenuLoad = action.payload;
		},
		SET_DATA_STRUCT_ENTERING_PTR:(state, action) => {
			state.mnu = {...state.mnu, dataStructEnteringPTR:action.payload};
		},
	 SET_MENU_PTR:(state, action) => {
			state.mnu = {...state.mnu, menuPTR:action.payload };
		},
		SET_CUR_ID:(state, action) => {
			state.curid = action.payload;
		},
		 SET_MENU_PTR_ID:(state, action) => {
			state.mnu = {...state.mnu, menuPTR_ID:action.payload };
		},
		SET_MENU_FORSE_RELOAD_FLAG:(state, action) => {
			state.mFRld = action.payload;
		},
		SET_VMODE:(state, action) => {
			state.mnu = {...state.mnu, vmode:action.payload };
		},
		SET_SELECTED_ID:(state, action) => {
			const selMenuIDs = state.mnu.selectedID;
    		selMenuIDs[state.mnu.menuPTR] = action.payload;
			state.mnu = {...state.mnu, selectedID: selMenuIDs};
		},
		SET_MENU_PUNKT_PBL_TAG:(state, action) => {
			let mnlst = state.mnulist;
    		mnlst[action.payload.idx].pbl = action.payload.pbl;
			state.mnulist = mnlst;
			state.mFRld = action.payload.pbl;
			},

		SET_MENU_PUNKT_ID_TAG:(state, action) => {
			let mnilst = state.mnulist;
    		mnilst[action.payload.idx].id = action.payload.id;
			state.mnulist = mnilst;
				state.mFRld = 'reload epta!';
		},

		SET_MENU_PUNKT_TTL_TAG:(state, action) => {
			let mntlst = state.mnulist;
    		mntlst[action.payload.idx].ttl = action.payload.ttl;
			state.mnulist = mntlst;
					state.mFRld = action.payload.ttl;
			
		},

		SET_MENU_PUNKT_VMODE_TAG:(state, action) => {
			let mlst = state.mnulist;
    		mlst[action.payload.idx].vmode = action.payload.vmode;
    		mlst[action.payload.idx].depth = action.payload.depth;
			state.mnulist = mlst;
		}
	}

})

export const { 
	SET_VMODE,
	UPDATE_VCONFIG_CONFIG,
	UPDATE_VCONFIG_VMODE,
	SET_CUR_ID,
	SET_SELECTED_ID,
	SET_MENU_PTR_ID,
	SET_MENU_PUNKT_ID_TAG,
	SET_MENU_PUNKT_PBL_TAG,
	SET_MENU_PUNKT_VMODE_TAG,
	SET_MENU_PUNKT_TTL_TAG,
	SET_MENU_FORSE_RELOAD_FLAG,
	SET_MENU_LOAD_FUNC,
	SET_MENU_LIST,
	SET_MENU_PTR,
	SET_DATA_STRUCT_ENTERING_PTR,
	SET_ACTION,
	SET_COUNT,
	RESET_COUNT } = menuSlice.actions

	export default menuSlice.reducer